import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { withRouter, Link, useHistory } from "react-router-dom"

// users
import user1 from "../../assets/images/users/avatar-1.jpg"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [username, setusername] = useState("")
  const history = useHistory();

  const handleLogout = (e) => {
    e.preventDefault()
    localStorage.removeItem("authApplicant")
    history.push("/applicants-login")
  }

  useEffect(() => {
    if (localStorage.getItem("authApplicant")) {
        const obj = JSON.parse(localStorage.getItem("authApplicant"))
        setusername(`${obj.fname} ${obj.lname}`)
    }
  }, [])

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" onClick={()=>{ history.push("/profile") }}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1"/>
            My Profile
          </DropdownItem>
          <div className="dropdown-divider"/>
          <DropdownItem tag="a" onClick={()=>{ history.push("/change-password") }}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1"/>
            Change Password
          </DropdownItem>
          <div className="dropdown-divider"/>
          <Link to="#" onClick={handleLogout} className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"/>
            <span>Signout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
